import PropTypes from "prop-types";
import styles from "./Transaction.module.css";
import axios from "axios";
import { useEffect, useState } from "react";
import config from "../../config/config";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import store from "../../Store/Store";
import { observer } from "mobx-react";
import ViewTransaction from "./ViewTransaction/ViewTransaction";
import FilterDate from "./FilterDate/FilterDate";
import PreviewImage from "./PreviewImage/PreviewImage";
import { Pagination } from "antd";
import { useNavigate } from "react-router";
import { Padding, Store } from "@mui/icons-material";
import NewUserPopup from "./NewUserPopup/NewUserPopup";

const Transaction = observer(({ className = "" }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [WalletInfo, setWalletinfo] = useState("Loading...");
  const [filterInput, setFilterInput] = useState("");
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [monthlyLimit, setMonthlyLimit] = useState();
  const [availableLimit, setAvailableLimit] = useState();
  const [selectedCompany, setCompany] = useState("");
  const [filteron, setFilterOn] = useState(false);
  const [TransactionData, setTransactionData] = useState([]);
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [finalSelectedMonth, finalSetSelectedMonth] = useState("");
  const [finalSelectedYear, finalSetSelectedYear] = useState("");
  const [invalidfilter, setinvalidfilter] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [flag, setFlag] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedEmailData, setSelectedEmailData] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [noDataForTheUser, setNoDataForTheUser] = useState(false);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [imageName, setImageName] = useState("");
  const [category, setCategory] = useState([]);
  const [hideNote, setHidenote] = useState(false);
  const [advKycStatus, setAdvKycStatus] = useState("");
  const [showBanner, setShowBanner] = useState(false);
  const [whitelistingStatus, setWhitelistingStatus] = useState("");
  const [onboardingStatus, setOnboardingStatus] = useState("");
  let startIndex;
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  if (selectedMonth !== "") {
    console.log("selectedMonth", selectedMonth);
  }

  useEffect(() => {
    if (!store.Company_Id) return;

    const fetchStatus = async () => {
      // setLoading(true);
      // setError("");
      try {
        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        const res = await fetch(
          `${config.kyc_api_endpoint}/user/status?company_id=${store.Company_Id}`,
          {
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedTokens.IdToken,
              aws_cognito_access_token: parsedTokens.AccessToken,
              "X-API-Key": process.env.REACT_APP_CUPI_API_KEY, // if required
            },
          }
        );

        const data = await res.json();
        const statusMap = Object.fromEntries(
          data.status.map((s) => [s.key, s.value])
        );
        setAdvKycStatus(statusMap["advanced-kyc"]);
        setWhitelistingStatus(statusMap["whitelisting"]);
        setOnboardingStatus(data.onboarding_status);
        store.setCompTempId(data.company_id);
        if (!res.ok || !data.success) {
          throw new Error(data.error || "Failed to fetch status");
        }

        // setStatus(data.status);
        // setOnboardingStatus(data.onboarding_status);
      } catch (err) {
        if (err.name !== "AbortError") {
          // setError(err.message || "Something went wrong");
        }
      } finally {
        // setLoading(false);
      }
    };

    fetchStatus();
  }, [store.company_temp_id]);

  useEffect(() => {
    setSelectedEmailData({});
    setData([]);
    setTransactionData([]);
    setFilteredData([]);
    setCurrentPageData([]);
    setSelectedEmail("");
    setFilterInput("");
    setName("");
    setSelectedUser(null);
    setAvailableLimit();
    setMonthlyLimit();
    const obj = {
      ledger_label: store.Company_Id,
    };
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    if (!tokens) {
      console.log("no auth");
      navigate("/login");
      return;
    } else {
    }
    try {
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_compnay_users`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then(async (res) => {
          setData(res.data.data);
          const user = store.selectedExpenseMobileno;
          if (user !== "") {
            const userData = res.data.data.find(
              (item) => item.mobile_no === user
            );
            // console.log("userData", userData);
            setMonthlyLimit(userData.monthlyLimit);
            setSelectedEmailData(userData);
            setSelectedUser(userData);
            if (store.selectedExpenseMobileno) {
              handleApply();
            }
            // store.setSelectedExpenseMobileNo("");
          }
        })
        .catch((er) => {
          console.log(er);
        });

      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Months are 0-indexed

      // Populate year options (current year back to 2000)
      const yearOptions = [];
      for (let year = currentYear; year >= 2023; year--) {
        yearOptions.push(year);
      }
      setYears(yearOptions);

      // Initially set months to be from January to December (for the case of previous years)
      setMonths(monthNames);
    } catch (err) {
      console.log("error in Getting Cupi users-->", err);
    }
    try {
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_company_detail`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then((res) => {
          setWalletinfo(res.data.data);
          store.setInsightAvilable(res.data.data.metabase_account_created);
        })
        .catch((er) => {
          console.log("error-->", er);
        });
      setCompany(store.companyName);

      setSelectedMonth(store.selectedMonth);
      setSelectedYear(store.selectedYear);
      setSelectedEmail(store.selectedEmail);
    } catch (err) {
      console.log("Error in walletInfo", err);
    }
    getEnabledCategories();
  }, [store.refresh]);

  // Update month options based on the selected year
  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      console.log("no auth");
      navigate("/login");
      return;
    } else {
    }
    if (location.pathname == "/content") {
    }
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    console.log("currentmonth", currentMonth);

    if (selectedYear === currentYear.toString()) {
      // If the current year is selected, limit months to current month
      setMonths(monthNames.slice(0, currentMonth + 1)); // up to the current month
    } else {
      // If a previous year is selected, allow all months
      setMonths(monthNames);
    }

    // Reset the selected month when year changes
    if (selectedYear == currentYear) {
      console.log(monthNames.slice(0, currentMonth));

      const month = monthNames.slice(0, currentMonth + 1);
      setSelectedMonth(month[month.length - 1]);
    } else {
      setSelectedMonth("");
    }
  }, [selectedYear]);

  //for Transaction And Filtered Data
  useEffect(() => {
    let updatedFilteredData = [...TransactionData]; // Start with TransactionData

    // Apply date filtering if minDate or maxDate is provided
    if (store.minDate !== "" || store.maxDate !== "") {
      updatedFilteredData = updatedFilteredData.filter((transaction) => {
        // Parse transaction date (e.g., "27-02-2025 11:59:32")
        const [datePart, timePart] = transaction.date.split(" ");
        const [day, month, year] = datePart.split("-");
        const [hours, minutes, seconds] = timePart.split(":");
        const txDate = new Date(
          `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
        );

        // Convert store.minDate and store.maxDate to Date objects
        const startDate = store.minDate ? new Date(store.minDate) : null;
        const endDate = store.maxDate ? new Date(store.maxDate) : null;

        // Set endDate to end of day if provided
        if (endDate) endDate.setHours(23, 59, 59, 999);

        // Filter logic
        const afterStart = startDate ? txDate >= startDate : true;
        const beforeEnd = endDate ? txDate <= endDate : true;

        return afterStart && beforeEnd;
      }, []);
    }

    // Update filteredData state
    setFilteredData(updatedFilteredData);

    // Pagination logic
    const startIndex = (currentPage - 1) * pageSize;
    const slicedData = updatedFilteredData.slice(
      startIndex,
      startIndex + pageSize
    );
    setCurrentPageData(slicedData);
  }, [TransactionData, currentPage, pageSize, store.minDate, store.maxDate]);

  //Function to get the transact ions data
  const handleApply = () => {
    const monthIndex =
      monthNames.findIndex((month) => month === selectedMonth) + 1;
    const formattedMonthIndex = String(monthIndex).padStart(2, "0");
    // console.log("selectedEmailDat--->a", selectedEmailData);

    if (
      selectedYear == "" ||
      !selectedEmailData ||
      selectedEmailData == {} ||
      selectedMonth == ""
    ) {
      setinvalidfilter(true);
      return;
    }
    setHidenote(true);
    setinvalidfilter(false);
    // console.log("selectedEmailDataselectedEmailData", selectedEmailData);
    store.setSelectedMobile_no(selectedEmailData.mobile_no);
    store.setSelectedEmail(selectedEmailData.email);
    store.setSelectedMonth(selectedMonth);
    store.setSelectedYear(selectedYear);

    // console.log("selectedEmailData", selectedEmailData.mobile_no);

    if (selectedEmailData == {} || selectedMonth == "" || selectedYear == "") {
      return;
    } else {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const obj = JSON.stringify({
        user_id: selectedEmailData.user_id,
        user_create_at: selectedEmailData?.create_at,
        ledger_label: store.Company_Id,
        year: selectedYear,
        month: formattedMonthIndex,
      });
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_company_user_transactions`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then((res) => {
          let availableLimit = 0;
          setName(selectedEmailData?.name?.toUpperCase());
          res.data.data.forEach((transaction) => {
            if (transaction.status === "processed") {
              availableLimit += transaction.amount;
            }
          });
          setAvailableLimit(availableLimit);
          setTransactionData(res.data.data);
          setFilteredData(res.data.data);
          setCurrentPage(1);
          if (res.data.data.length < 1) {
            setNoDataForTheUser(true);
          } else {
            setNoDataForTheUser(false);
          }
        })
        .catch((er) => {
          console.log("error-->", er);
        });
    }
    store.setMinDate("");
    store.setMaxDate("");
    finalSetSelectedMonth(selectedMonth);
    finalSetSelectedYear(selectedYear);
  };

  //Function To handle year change
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    store.setYear(event.target.value);
  };

  //Function To handle Month change
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    store.setMonth(event.target.value);
  };
  //For getting unique emails from the Data
  const uniqueUsers = Array.from(
    new Set(
      data.map((item) =>
        JSON.stringify({ name: item.name, mobile_no: item.mobile_no })
      )
    )
  ).map((item) => JSON.parse(item));

  // Function to Show transaction details with images
  const handleStore = (detail, category, index) => {
    console.log('---------',detail);
    
    store.setDate(detail.date);
    store.setDebit(detail.amount);
    store.setPaidTo(detail.paid_to);
    store.setPurpose(detail.purpose);
    store.setUPIId(detail.upi_id);
    store.setUtr(detail.utr);
    store.setTxnId(detail.transaction_id);
    store.setStatus(detail.status);
    store.setCategory(category);
    store.setTxnStatus(detail.cupi_approval_status);
    store.setIndex(index);
    store.setResubmitReason(detail.cupi_approval_reason);
    store.setNewPurpose(detail?.transaction_note);
  };

  // Function to handle pagination change
  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  // Function to generate CSV download// Function to generate CSV download
  const generateCSV = (data) => {
    if (!data || !data.length) return "";

    // Transform the data to replace category_id with category name
    const transformedData = data.map((item) => {
      const newItem = { ...item };
      if (newItem.category_id !== undefined) {
        const categoryData = getcategoryByCategoryId(newItem.category_id);
        delete newItem.category_id;
        newItem.category = categoryData ? categoryData.categoryName : "N/A";
        newItem.purpose =
          newItem && newItem.purpose !== "Expense" ? newItem.purpose : "N/A";
      }
      return newItem;
    });

    const headers = Object.keys(transformedData[0]).join(","); // Create the header row
    const rows = transformedData.map((obj) =>
      Object.values(obj)
        .map((value) =>
          // Handle values that might contain commas or quotes
          typeof value === "string" &&
          (value.includes(",") || value.includes('"'))
            ? `"${value.replace(/"/g, '""')}"`
            : value
        )
        .join(",")
    ); // Map each object to a row
    return [headers, ...rows].join("\n"); // Combine headers and rows
  };

  // Function to trigger CSV download (unchanged)
  const downloadCSV = () => {
    if (TransactionData == [] || TransactionData.length == 0) {
      return;
    }
    const csvContent = generateCSV(TransactionData);
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    a.download = `${selectedEmailData.name}_(${selectedEmailData.mobile_no})_${selectedYear}_${selectedMonth}.csv`;
    a.click();
    URL.revokeObjectURL(url); // Cleanup
  };

  // Your existing getcategoryByCategoryId function (unchanged)
  const getcategoryByCategoryId = (categoryId) => {
    if (!category || !Array.isArray(category)) {
      return null; // Return null if category data is invalid
    }
    const foundCategory = category.find(
      (item) => item.categoryId === categoryId
    );
    return foundCategory || null;
  };

  const getEnabledCategories = async () => {
    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const Obj = {
        ledger_label: store.Company_Id,
      };

      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_categories`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: Obj,
      };
      axios
        .request(payload)
        .then((res) => {
          setCategory(res.data.data);
        })
        .catch((err) => {
          console.log("Error %o", err);
        });
    } catch (err) {
      console.log("error %o", err);
    }
  };

  const getStatusConfig = (TxnStatus, status) => {
    const isProcessed = status === "processed";
    if (status == "processed") {
      switch (TxnStatus) {
        case "approved":
          return isProcessed
            ? {
                text: "SPEND APPROVED",
                image: "/Check_Icon.svg",
                className: styles.dataApproved,
              }
            : {
                text: "NA",
                image: "/na.svg",
                className: styles.dataNA,
              };
        case "pending_receipt_upload":
          return {
            text: "YET TO SUBMIT BILL",
            image: "/na.svg",
            className: styles.dataNotSubmitted,
          };
        case "rejected":
          return {
            text: "SPEND REJECTED",
            image: "/X-Icon.svg",
            className: styles.dataRejected,
          };
        case "receipt_submitted_pending_admin_approval":
          return {
            text: "BILL SUBMITTED",
            image: "/hourGlass-icon.svg",
            className: styles.dataBillSubmitted,
          };
        case "pending_receipt_resubmit_requested":
          return {
            text: "RESUBMIT BILL",
            image: "/refresh.svg",
            className: styles.dataResubmit,
          };
        default:
          return {
            text: "NA",
            image: "/na.svg",
            className: styles.dataNA,
          };
      }
    } else {
      return {
        text: "NA",
        image: "/na.svg",
        className: styles.dataNA,
      };
    }
  };

  const renderStatus = (txnStatus, status, index) => {
    let newStatus = txnStatus;
    const { text, image, className } = getStatusConfig(newStatus, status);

    return (
      <div className={className}>
        {newStatus != "cupi_approval_status" &&
          newStatus != "NA" &&
          newStatus != "pending_receipt_upload" &&
          status === "processed" && (
            <img alt={text} src={image} className={styles.btn_img} />
          )}
        <span>{text}</span>
      </div>
    );
  };

  return (
    <div className={[styles.pageContainer, className].join(" ")}>
      <div className={styles.frameParent}>
        <div className={styles.frameGroup}>
          <div className={styles.split}>
            <div>
              <div className={styles.cards16pxWrapper}>
                <div className={styles.cards16px}>
                  <div className={styles.saveMoney1044644423Parent}>
                    <div className={styles.saveMoney1044644423}>
                      <img
                        className={styles.vectorIcon}
                        alt=""
                        src="/vector.svg"
                      />
                    </div>
                    <div className={styles.availableBalanceParent}>
                      <div className={styles.availableBalance}>
                        Available Balance*
                      </div>
                      <div className={styles.div}>
                        ₹{WalletInfo.balance || "Loading..."}
                      </div>
                    </div>
                  </div>

                  {store.Company_Id != "AxisDemo" && (
                    <div className={styles.saveMoney1044644423Parent}>
                      <div className={styles.saveMoney1044644423}>
                        <img
                          className={styles.vectorIcon}
                          alt=""
                          src="/wallet.svg"
                        />
                      </div>
                      <div className={styles.availableBalanceParent}>
                        <div className={styles.availableBalance}>
                          Account Details*
                          <div className={styles.tiptool}>
                            {/* <img
                              src="/alert-circle.svg"
                              alt=""
                              className={styles.icon}
                            />
                            <span className={styles.Texttooltip}>
                              Please load money only from company's validated
                              Bank account to the wallet.
                            </span> */}
                          </div>
                        </div>

                        <div className={styles.div16}>
                          <div>Ac.no</div>
                          <div>:</div>
                          <div>{WalletInfo?.van?.acc_no || "Loading..."}</div>
                        </div>
                        <div className={styles.div16}>
                          <div>IFSC</div>
                          <div>:</div>
                          <div>{WalletInfo?.van?.ifsc || "Loading..."}</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {!hideNote && (
                <div className={styles.noteconatiner}>
                  <span className={styles.divSpan}>
                    <span className={styles.divSpanBold}>Note:</span> Please
                    select user Phone number, year, month to fetch user
                    transaction history by month.
                  </span>
                </div>
              )}
              <div className={styles.filterContainer}>
                <div className={styles.filterOptions}>
                  <Autocomplete
                    disablePortal
                    options={uniqueUsers} // Updated to use user objects
                    getOptionLabel={
                      (option) =>
                        option ? `${option.name} (${option.mobile_no})` : "" // Show name and phone
                    }
                    InputProps={{
                      style: {
                        border: "none",
                      },
                    }}
                    filterOptions={(options, { inputValue }) => {
                      // Custom filter for name or phone number
                      const input = inputValue.toLowerCase();
                      return options.filter(
                        (option) =>
                          option.name.toLowerCase().includes(input) ||
                          option.mobile_no.toLowerCase().includes(input)
                      );
                    }}
                    noOptionsText={
                      filterInput &&
                      !uniqueUsers.some(
                        (user) =>
                          user.name
                            .toLowerCase()
                            .includes(filterInput.toLowerCase()) ||
                          user.mobile_no
                            .toLowerCase()
                            .includes(filterInput.toLowerCase())
                      )
                        ? "User not found"
                        : "No options"
                    }
                    onInputChange={(event, newInputValue) => {
                      setinvalidfilter(false);
                      setFilterInput(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const selectedData = data.find(
                          (item) =>
                            item.mobile_no === newValue.mobile_no &&
                            item.name === newValue.name
                        );
                        if (selectedData) {
                          store.setmonthlyLimit(selectedData.monthlyLimit);
                          setMonthlyLimit(selectedData.monthlyLimit);
                          console.log("selectedData", selectedData);

                          setSelectedEmailData(selectedData); // Set full user data
                          setSelectedUser(selectedData); // Set selected user object
                          setFilterInput(
                            `${selectedData.name} (${selectedData.mobile_no})`
                          ); // Sync input
                        }
                      } else {
                        setSelectedEmailData({});
                        setSelectedUser(null);
                        setNoDataForTheUser(false);
                        setFilterInput("");
                      }
                      setinvalidfilter(false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          width: "220px",
                          height: "56px",
                        }}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            borderRadius: "12px",
                            // boxShadow: invalidfilter
                            //   ? "0 2px 5px red"
                            //   : "0 2px 5px rgba(92, 91, 91, 0.2)",
                            height: "56px",
                            border: invalidfilter ? "1px solid red" : "",
                            color: invalidfilter ? "red" : "",
                          },
                        }}
                        placeholder="Search by Name or Phone..."
                      />
                    )}
                    value={selectedUser} // Bind to full user object
                  />
                  <div className={styles.filteryear_month}>
                    <FormControl>
                      <Select
                        value={selectedYear}
                        onChange={handleYearChange}
                        displayEmpty
                        sx={{
                          width: "120px",
                          height: "56px",
                          border: invalidfilter ? "1px solid red" : "",
                          color: invalidfilter ? "red" : "",
                          borderRadius: "10px",
                          fontFamily: "roboto",
                          color: "#49454F",
                          fontSize: "16px",
                        }}
                      >
                        <MenuItem value="">Year</MenuItem>
                        {years.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl>
                      <Select
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        displayEmpty
                        sx={{
                          width: "120px",
                          height: "56px",
                          border: invalidfilter ? "1px solid red" : "",
                          color: invalidfilter ? "red" : "",
                          borderRadius: "10px",
                          fontFamily: "roboto",
                          color: "#49454F",
                          fontSize: "16px",
                        }}
                      >
                        <MenuItem value="">Month</MenuItem>
                        {months.map((month) => (
                          <MenuItem key={month} value={month}>
                            {month.toString().padStart(2, "0")}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <button
                    className={styles.Button}
                    onClick={() => {
                      handleApply();
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div>
              {!showBanner && (
                <NewUserPopup
                  advKycStatus={advKycStatus}
                  whitelistingStatus={whitelistingStatus}
                  onboardingStatus={onboardingStatus}
                  setShowBanner={setShowBanner}
                />
              )}
            </div>
          </div>
          <div className={styles.feeStatementDataTable}>
            <div className={styles.top}>
              <div className={styles.latestAccountTransactionParent}>
                <div className={styles.latestAccountTransaction}>
                  <span className={styles.ChnageColor}>
                    Account Transactions :{" "}
                  </span>{" "}
                  {name ? name.toUpperCase() : ""}
                </div>
                <div className={styles.filter}>
                  <button
                    className={styles.filterLinesParent}
                    onClick={(e) => {
                      setFilterOn(true);
                      e.stopPropagation();
                    }}
                  >
                    <img
                      className={styles.filterLinesIcon}
                      alt=""
                      src="/filterlines.svg"
                    />
                    <div className={styles.labelText2}>Filter</div>
                  </button>
                  {filteron && (
                    <div
                      className={styles.newUsersOverlay1}
                      onClick={() => {
                        setFilterOn(false);
                      }}
                    >
                      <FilterDate
                        isVisible={filteron}
                        users={selectedUser}
                        onClose={() => {
                          setFilterOn(false);
                        }}
                        selectedMonth={finalSelectedMonth}
                        selectedYear={finalSelectedYear}
                      />
                    </div>
                  )}
                  <button
                    className={styles.download01Parent}
                    onClick={downloadCSV}
                  >
                    <img
                      className={styles.filterLinesIcon}
                      alt=""
                      src="/download01.svg"
                    />
                    <div className={styles.labelText2}>Export</div>
                  </button>
                  <button
                    className={styles.reLoadTable}
                    onClick={() => {
                      handleApply();
                    }}
                  >
                    <img
                      className={styles.vectorIcon1}
                      alt=""
                      src="/vector7.svg"
                    />
                  </button>
                </div>
              </div>
              <div className={styles.latestAccountTransaction1}>
                Total Monthly Spend :
                <div className={styles.allowedTransactions}>
                  {availableLimit && monthlyLimit
                    ? `  ${Number(availableLimit).toFixed(2)}/${monthlyLimit}`
                    : ""}
                </div>
              </div>
            </div>
            <div className={styles.scrollableTableContainer}>
              <div className={styles.tableWrapper}>
                <table className={styles.table}>
                  <thead className={styles.tableHead}>
                    <tr className={styles.tableHeaderRowCellcontainer}>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv1}>
                          DATE
                        </div>
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv}>
                          PURPOSE
                        </div>
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv}>
                          PAID TO
                        </div>
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv1}>
                          AMOUNT PAID
                        </div>
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv}>
                          UPI ID
                        </div>
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv}>
                          UTR/RRN
                        </div>
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv}>
                          TXN STATUS
                        </div>
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv1}>
                          APPROVAL STATUS
                        </div>
                        {/* <div className={styles.tableHeaderRowCelldiv33}>
                          CATEGORY
                        </div> */}
                      </th>
                      <th className={styles.tableHeaderRowCell}>
                        <div className={styles.tableHeaderRowCelldiv1}>
                          ACTION
                        </div>
                      </th>
                    </tr>
                  </thead>
                  {currentPageData != "" && currentPageData != [] && (
                    <tbody
                      className={styles.tablebody}
                      style={{ Padding: "20px" }}
                    >
                      {currentPageData &&
                        currentPageData.map((detail, index) => {
                          const categoryData = getcategoryByCategoryId(
                            detail.category_id
                          );
                          return (
                            <tr key={index} className={styles.tableBodyrow}>
                              <td className={styles.tableBodydata}>
                                <div className={styles.data1}>
                                  {detail?.date.split(" ")[0]}
                                </div>
                              </td>
                              <td className={styles.tableBodydata}>
                                {detail?.purpose == "N/A" ||
                                detail?.purpose == "Expense" ? (
                                  <div className={styles.data}>N/A</div>
                                ) : (
                                  <div className={styles.data4}>
                                    {detail?.purpose.slice(0, 15)}
                                    {detail?.purpose.length > 15 ? "..." : ""}
                                  </div>
                                )}
                              </td>
                              <td className={styles.tableBodydata}>
                                <div className={styles.data4}>
                                  {detail?.paid_to.slice(0, 15)}
                                  {detail?.paid_to.length > 15 ? "..." : ""}
                                </div>
                              </td>
                              <td className={styles.tableBodydatain}>
                                <div className={styles.data23}>
                                  {Number(detail?.amount).toFixed(2)}
                                </div>
                              </td>
                              <td className={styles.tableBodydata}>
                                <div className={styles.data4}>
                                  {detail?.upi_id}
                                </div>
                              </td>
                              <td className={styles.tableBodydata}>
                                <div className={styles.data2}>
                                  {detail?.utr}
                                </div>
                              </td>
                              <td className={styles.tableBodydata}>
                                <div
                                  className={
                                    detail.status == "processed"
                                      ? styles.tableBodydataStatusComp
                                      : detail.status == "failed"
                                      ? styles.tableBodydataStatusRever
                                      : styles.tableBodydataStatus
                                  }
                                >
                                  {detail.status == "processed"
                                    ? "PROCESSED"
                                    : detail.status == "failed"
                                    ? "REVERSED"
                                    : "PROCESSING"}
                                </div>
                              </td>
                              <td className={styles.tableBodydata3}>
                                {renderStatus(
                                  detail.cupi_approval_status,
                                  detail.status,
                                  index
                                )}

                                {/* <div className={styles.data26}>
                                  {categoryData?.categoryName || "NA"}
                                </div> */}
                              </td>
                              <td className={styles.tableBodydatabtn}>
                                <button
                                  className={styles.button}
                                  onClick={() => {
                                    handleStore(
                                      detail,
                                      categoryData?.categoryName,
                                      index
                                    );
                                    setFlag(true);
                                  }}
                                >
                                  <img
                                    alt=""
                                    src="/eye.svg"
                                    className={styles.btn_img}
                                  />
                                  View More
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
            {currentPageData == "" ? (
              noDataForTheUser ? (
                <div className={styles.noHistory}>
                  No transactions found for this user.
                </div>
              ) : (
                <div className={styles.noHistory}>
                  Please Select the User email, Year and Month to get started.
                </div>
              )
            ) : (
              ""
            )}
            <div
              className={currentPageData == "" ? styles.bottom1 : styles.bottom}
            >
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={filteredData.length}
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
      {flag && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            setFlag(false);
            setShowImage(false);
          }}
        >
          <ViewTransaction
            isVisible={flag}
            onClose={() => setFlag(false)}
            openImg={() => {
              setShowImage(true);
            }}
            closeImg={() => {
              setShowImage(false);
            }}
            setimg={(data) => {
              setSelectedImage(data);
            }}
            setName={(data) => {
              setImageName(data);
            }}
          />
          <PreviewImage
            isVisible={flag && showImage}
            CloseImg={() => {
              setShowImage(false);
            }}
            image={selectedImage}
            name={imageName}
          />
        </div>
      )}
    </div>
  );
});

Transaction.propTypes = {
  className: PropTypes.string,
};

export default Transaction;
